import { gql } from '@apollo/client';

import { USER_FRAGMENT } from './userFragment';

export const GET_USER_BY_ORGANIZATION = gql`
  query GetUserByOrganization($id: ID!) {
    loggedInUserByOrganization(orgId: $id) {
      ...userFragment
      assignments {
        adAccountId
        adAccountName
        assignment
      }
    }
  }
  ${USER_FRAGMENT}
`;
